/**
 * ERGOS Modules (Fontes Geradoras) - Fonte de Verdade
 * 
 * Lista oficial dos módulos ERGOS usados em:
 * - Biblioteca de Sugestões
 * - Resolver de Recomendações
 * - Motor de Análise
 * 
 * IMPORTANTE: Esta é a única fonte de verdade para módulos ERGOS.
 * Qualquer alteração aqui deve ser refletida em toda a aplicação.
 */

export interface ErgosModule {
  key: string;
  label: string;
  description?: string;
}

export const ERGOS_MODULES: readonly ErgosModule[] = [
  {
    key: "pressao_e_tempo",
    label: "Pressão e tempo",
    description: "Avalia a pressão temporal e demandas de produtividade",
  },
  {
    key: "atencao",
    label: "Atenção",
    description: "Avalia o nível de atenção requerido nas atividades",
  },
  {
    key: "complexidade",
    label: "Complexidade",
    description: "Avalia a complexidade das tarefas executadas",
  },
  {
    key: "monotonia",
    label: "Monotonia",
    description: "Avalia a repetitividade e monotonia das atividades",
  },
  {
    key: "raciocinio_e_processos_centrais",
    label: "Raciocínio e processos centrais",
    description: "Avalia demandas cognitivas de raciocínio e tomada de decisão",
  },
  {
    key: "iniciativa",
    label: "Iniciativa",
    description: "Avalia o nível de autonomia e proatividade requerido",
  },
  {
    key: "isolamento",
    label: "Isolamento",
    description: "Avalia o grau de isolamento social no trabalho",
  },
  {
    key: "horas_e_turnos_de_trabalho",
    label: "Horas e turnos de trabalho",
    description: "Avalia jornada de trabalho e turnos",
  },
  {
    key: "relacionamento_no_trabalho",
    label: "Relacionamento no trabalho",
    description: "Avalia qualidade dos relacionamentos interpessoais",
  },
  {
    key: "demandas_gerais",
    label: "Demandas Gerais",
    description: "Avalia demandas gerais do ambiente de trabalho",
  },
] as const;

/**
 * Helper: Normalizar chave de módulo
 * Remove espaços, converte para lowercase
 */
export function normalizeModuleKey(key: string): string {
  return key.trim().toLowerCase();
}

/**
 * Helper: Buscar módulo por chave
 */
export function getModuleByKey(key: string): ErgosModule | undefined {
  const normalizedKey = normalizeModuleKey(key);
  return ERGOS_MODULES.find((m) => m.key === normalizedKey);
}

/**
 * Helper: Validar se chave de módulo existe
 */
export function isValidModuleKey(key: string): boolean {
  return !!getModuleByKey(key);
}
